




















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getPlansData } from '@/web/utils/plans';
import { getConfig } from '@/web/utils/configuration';
import PlanCardSimple from '@/web/components/signup/PlanCardSimple.vue';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  components: {
    PlanCardSimple,
  },
  props: {
    initalSubscriptionType: {
      type: String,
      default: 'monthly',
    },
    initalSelectedPlanId: {
      type: Number,
      required: false,
    },
    freeTrial: {
      type: Boolean,
      default: false,
    },
    freeTrialDays: {
      type: Number,
      default: 7,
    },
  },
  data() {
    return {
      subscriptionType: undefined as string | undefined,
      selectedPlanId: undefined as number | undefined,
    };
  },
  computed: {
    ...mapGetters('user', [
      'userPlans',
      'hasSubscriptionType',
      'hasMultiPlans',
    ]),
    ...mapGetters({
      affiliateCode: 'globals/affiliateCode',
    }),
    plansData() {
      if (!this.subscriptionType) return [];
      return [...(this.userPlans || [])]
        .filter(plan => !(plan.hide_for_affiliates && this.affiliateCode))
        .sort((planA, planB) => planA.tier - planB.tier)
        .map(plan =>
          getPlansData(
            plan,
            this.subscriptionType,
            this.selectedPlanId,
            this.freeTrial,
            this.freeTrialDays,
            this.initalSubscriptionType
          )
        );
    },
    config() {
      return getConfig();
    },
  },
  methods: {
    sanitize,
    selectPlan(planId) {
      this.selectedPlanId = planId;
      if (
        this.subscriptionType !== this.initalSubscriptionType ||
        this.selectedPlanId !== this.initalSelectedPlanId
      ) {
        this.$parent.$emit('select-plan', {
          planId: planId,
          subscriptionType: this.subscriptionType,
        });
      }
      this.$emit('close');
    },
    setSubscriptionType(type) {
      this.subscriptionType = type;
    },
  },
  mounted() {
    this.subscriptionType = this.initalSubscriptionType;
    this.selectedPlanId = this.initalSelectedPlanId;
  },
});
